
/**
 * Cache to register icons for the current user
 * @kind cache
 * @class Icons
 * @description Custom lookup cache for Icons
 * @usage let lookup = await Grape.cache.get('Icons');
 */
export default {
	name: 'Icons',
	options: {
		refresh: function (cb) {
			cb(null, [
				{ 'icon': 'fas fa-umbrella-beach', 'text': '\uf5ca' },
				{ 'icon': 'fas fa-medkit', 'text': '\uf0fa' },
				{ 'icon': 'fa fa-star', 'text': '\uf005' },
				{ 'icon': 'fa fa-briefcase', 'text': '\uf0b1' },
				{ 'icon': 'fa fa-graduation-cap', 'text': '\uf19d' },
				{ 'icon': 'fa fa-child', 'text': '\uf1ae' }
			]);
		}
	}
};
